'use strict';

var GridCollapsePanelButtonController = function GridCollapsePanelButtonController($scope) {
  $scope.collapsePanel = function () {
    $scope.$emit('collapsable-panel:collapse');
  };
};
GridCollapsePanelButtonController.$inject = ['$scope'];
module.exports = GridCollapsePanelButtonController;